/**
 * Stay Fresh exit popup: companion script for sections/sf-exit-popup.liquid.
 * Native replacement for the Poptin app. No dependencies, no third-party requests.
 *
 * Mouse devices  Opens when the cursor leaves through the top of the window (towards the
 *                tabs, address bar or close button), plus an optional timer.
 * Touch devices  A small bar slides up after real engagement; tapping it opens the form.
 *                The back button is never intercepted: Google treats "back button
 *                hijacking" as a spam violation (enforced since 15 June 2026).
 * Frequency      Kept in a first-party cookie. This theme wipes localStorage whenever a
 *                visitor leaves the page they landed on, so localStorage can't hold it.
 *                The cookie is re-read before every automatic open, so open tabs share one
 *                limit, and rewritten on every page view because Safari deletes cookies
 *                set by scripts 7 days after they were last written.
 * Signups        A normal post of Shopify's own customer form, like the footer newsletter.
 *                No background (AJAX) post: Shopify's spam protection answers those with
 *                errors or challenges. Shopify sends the visitor back to the same page with
 *                ?customer_posted=true#sfp-form and the popup reopens on the thank-you step.
 * Lead details   Page, landing page, traffic source and device go into the customer note,
 *                which the Shopify Flow lead email includes.
 * Events         Publishes sf_exit_popup_shown, sf_exit_popup_bar_shown and
 *                sf_exit_popup_signup customer events (for pixels) and fires
 *                "sf:exit-popup:signup" on document.
 * QA             Add ?sf_popup=open, ?sf_popup=bar or ?sf_popup=reset to any page.
 */
(function () {
  'use strict';

  var COOKIE = 'sf_exit_popup';
  var LANDING_KEY = 'sf_exit_popup_landing';
  var BAR_FOLLOW_SECONDS = 30 * 60;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var NOISY_PARAMS = /^(_su_rec|_su_rec_id|srsltid|utm_content|_pos|_sid|_ss|_fid|pr_prod_strat|pr_rec_id|pr_rec_pid|pr_ref_pid|pr_seq)$/;

  var DOMAINS = [
    'gmail.com', 'googlemail.com', 'yahoo.com', 'ymail.com', 'rocketmail.com', 'hotmail.com',
    'outlook.com', 'live.com', 'msn.com', 'aol.com', 'icloud.com', 'me.com', 'mac.com',
    'comcast.net', 'att.net', 'sbcglobal.net', 'bellsouth.net', 'verizon.net', 'charter.net',
    'cox.net', 'earthlink.net', 'frontier.com', 'windstream.net', 'centurylink.net',
    'protonmail.com', 'proton.me', 'gmx.com', 'gmx.net', 'gmx.de', 'web.de', 't-online.de',
    'mail.com', 'zoho.com', 'yahoo.ca', 'hotmail.ca', 'live.ca', 'shaw.ca', 'rogers.com',
    'sympatico.ca', 'telus.net', 'yahoo.co.uk', 'hotmail.co.uk', 'live.co.uk', 'btinternet.com',
    'sky.com', 'virginmedia.com', 'yahoo.fr', 'hotmail.fr', 'orange.fr', 'free.fr',
    'laposte.net', 'sfr.fr', 'yahoo.de', 'hotmail.de', 'outlook.de', 'yahoo.es', 'hotmail.es',
    'yahoo.it', 'hotmail.it', 'libero.it', 'virgilio.it', 'outlook.it', 'bigpond.com',
    'optusnet.com.au', 'yahoo.com.au', 'hotmail.com.au', 'outlook.com.au'
  ];
  var MAJOR = ['gmail.com', 'yahoo.com', 'hotmail.com', 'outlook.com', 'aol.com', 'icloud.com', 'comcast.net', 'sbcglobal.net', 'bellsouth.net'];
  // Real domains one letter away from a common one: never "correct" these.
  var REAL = ['aim.com', 'aon.com', 'email.com', 'cloud.com', 'juno.com', 'usa.com', 'post.com', 'gm.com', 'ge.com', 'ms.com'];
  var COM_TYPO = /^(co|cm|om|con|cmo|cpm|ocm|comm|vom|xom|c0m|coom|comn|cim)$/;
  var NET_TYPO = /^(ne|nt|ner|nte|bet|met|nett|nwt)$/;

  var instance = null;

  /* ---------- Stored state (first-party cookie) ---------- */

  function nowSec() {
    return Math.floor(Date.now() / 1000);
  }

  function readState() {
    var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + COOKIE + '=([^;]*)'));
    if (!match) return {};
    try {
      return JSON.parse(decodeURIComponent(match[1])) || {};
    } catch (e) {
      return {};
    }
  }

  function writeState(patch) {
    var state = readState();
    Object.keys(patch).forEach(function (key) {
      state[key] = patch[key];
    });
    document.cookie = COOKIE + '=' + encodeURIComponent(JSON.stringify(state)) +
      '; path=/; max-age=31536000; SameSite=Lax' + (window.location.protocol === 'https:' ? '; Secure' : '');
  }

  function clearState() {
    document.cookie = COOKIE + '=; path=/; max-age=0; SameSite=Lax';
  }

  /* ---------- Helpers ---------- */

  function publish(name, data) {
    try {
      var analytics = window.Shopify && window.Shopify.analytics;
      if (analytics && typeof analytics.publish === 'function') analytics.publish(name, data || {});
    } catch (e) {
      /* analytics must never break the popup */
    }
  }

  function finePointer() {
    return !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  }

  // The fixed or sticky element that holds el, if any (crossing out of shadow roots).
  function pinnedBox(el) {
    while (el && el !== document.body && el !== document.documentElement) {
      var position = window.getComputedStyle(el).position;
      if (position === 'fixed' || position === 'sticky') return el;
      el = el.parentElement || (el.getRootNode && el.getRootNode().host) || null;
    }
    return null;
  }

  function cleanUrl() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('customer_posted');
      window.history.replaceState(window.history.state, '', url.pathname + url.search);
    } catch (e) {
      /* leave the address bar alone */
    }
  }

  /* ---------- Email typo hints ---------- */

  function distance(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = [];
    var i;
    var j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      var row = [i];
      var best = i;
      for (j = 1; j <= b.length; j++) {
        row[j] = Math.min(prev[j] + 1, row[j - 1] + 1, prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1));
        if (row[j] < best) best = row[j];
      }
      if (best > max) return max + 1;
      prev = row;
    }
    return prev[b.length];
  }

  function suggestEmail(email) {
    var at = email.lastIndexOf('@');
    if (at < 1) return '';
    var local = email.slice(0, at);
    var domain = email.slice(at + 1).toLowerCase();
    var dot = domain.indexOf('.');
    if (dot < 1 || DOMAINS.indexOf(domain) !== -1 || REAL.indexOf(domain) !== -1) return '';
    var label = domain.slice(0, dot);
    var ending = domain.slice(dot + 1);
    // A known provider with a mistyped ending: gmail.co, yahoo.con, comcast.ner
    if (COM_TYPO.test(ending) && DOMAINS.indexOf(label + '.com') !== -1) return local + '@' + label + '.com';
    if (NET_TYPO.test(ending) && DOMAINS.indexOf(label + '.net') !== -1) return local + '@' + label + '.net';
    // Gmail and iCloud addresses only exist as .com
    if ((label === 'gmail' || label === 'icloud') && ending !== 'com') return local + '@' + label + '.com';
    // Any other ending on a known provider is usually a real country domain: yahoo.gr, hotmail.com.ar
    for (var k = 0; k < DOMAINS.length; k++) {
      if (DOMAINS[k].slice(0, DOMAINS[k].indexOf('.')) === label) return '';
    }
    // Too short to guess safely: gm.com, hp.com
    if (label.length < 4) return '';
    var best = '';
    var bestScore = 3;
    DOMAINS.forEach(function (candidate) {
      var limit = MAJOR.indexOf(candidate) !== -1 && domain.length >= 8 ? 2 : 1;
      var score = distance(domain, candidate, limit);
      if (score <= limit && score < bestScore) {
        best = candidate;
        bestScore = score;
      }
    });
    if (best) return local + '@' + best;
    var fixed = domain.replace(/\.(con|cmo|cpm|ocm|comm|vom|xom|c0m)$/, '.com');
    return fixed !== domain ? local + '@' + fixed : '';
  }

  /* ---------- Where the visitor came from (saved in the customer note) ---------- */

  function rememberLanding() {
    try {
      if (window.sessionStorage.getItem(LANDING_KEY)) return;
      window.sessionStorage.setItem(LANDING_KEY, JSON.stringify({ url: window.location.href, ref: document.referrer || '' }));
    } catch (e) {
      /* storage blocked: the current page stands in for the landing page */
    }
  }

  function landing() {
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(LANDING_KEY) || 'null');
      if (saved && saved.url) return saved;
    } catch (e) {
      /* fall through */
    }
    return { url: window.location.href, ref: document.referrer || '' };
  }

  function tidyUrl(href) {
    try {
      var url = new URL(href, window.location.href);
      var keep = [];
      url.searchParams.forEach(function (value, key) {
        if (!NOISY_PARAMS.test(key)) keep.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      });
      var out = url.origin + url.pathname + (keep.length ? '?' + keep.join('&') : '');
      return out.length > 300 ? out.slice(0, 297) + '...' : out;
    } catch (e) {
      return String(href).slice(0, 300);
    }
  }

  function trafficSource(entry) {
    var params;
    try {
      params = new URL(entry.url).searchParams;
    } catch (e) {
      return 'Unknown';
    }
    if (params.get('gclid') || params.get('gad_source') || params.get('gbraid') || params.get('wbraid')) return 'Google Ads';
    if (params.get('msclkid')) return 'Microsoft Ads';
    if (params.get('sca_ref')) return 'Affiliate link (' + params.get('sca_ref').split('.')[0] + ')';
    if (params.get('utm_source')) return params.get('utm_source') + (params.get('utm_medium') ? ' / ' + params.get('utm_medium') : '');
    if (params.get('fbclid')) return 'Facebook';
    if (entry.ref) {
      try {
        var host = new URL(entry.ref).hostname.replace(/^www\./, '');
        if (host && host !== window.location.hostname.replace(/^www\./, '')) return host;
      } catch (e) {
        /* fall through */
      }
    }
    return 'Direct';
  }

  function sourceNote() {
    var entry = landing();
    var device = finePointer() ? 'Desktop' : (window.innerWidth < 750 ? 'Phone' : 'Tablet');
    return [
      'Signed up through the exit popup',
      'Page: ' + tidyUrl(window.location.href),
      'Landing page: ' + tidyUrl(entry.url),
      'Traffic source: ' + trafficSource(entry),
      'Device: ' + device
    ].join('\n');
  }

  /* ---------- Popup ---------- */

  function create(root) {
    var dialog = root.querySelector('[data-sfp-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return null;

    var html = document.documentElement;
    var bar = root.querySelector('[data-sfp-bar]');
    var form = root.querySelector('form');
    var steps = root.querySelectorAll('[data-sfp-step]');
    var emailInput = root.querySelector('[data-sfp-email]');
    var nameInput = root.querySelector('[data-sfp-name]');
    var firstInput = root.querySelector('[data-sfp-first]');
    var lastInput = root.querySelector('[data-sfp-last]');
    var noteInput = root.querySelector('[data-sfp-note]');
    var errorBox = root.querySelector('[data-sfp-error]');
    var suggestBox = root.querySelector('[data-sfp-suggest]');
    var suggestBtn = root.querySelector('[data-sfp-suggest-apply]');
    var submitBtn = root.querySelector('[data-sfp-submit]');
    var copyBtn = root.querySelector('[data-sfp-copy]');
    var codeEl = root.querySelector('[data-sfp-code]');
    var css = document.querySelector('link[data-sfp-css]');

    function num(name, fallback) {
      var value = parseInt(root.getAttribute(name), 10);
      return isNaN(value) ? fallback : value;
    }

    var opts = {
      design: root.getAttribute('data-design-mode') === 'true',
      armDelay: num('data-arm-delay', 3) * 1000,
      timer: num('data-timer', 0) * 1000,
      frequency: Math.max(num('data-frequency-days', 1), 1) * 86400,
      mobile: root.getAttribute('data-mobile') === 'true',
      mobileDelay: num('data-mobile-delay', 20) * 1000,
      saveSource: root.getAttribute('data-save-source') === 'true',
      subscribed: root.getAttribute('data-subscribed') === 'true',
      editorStep: root.getAttribute('data-editor-step') === 'done' ? 'done' : 'form'
    };

    var cleanups = [];
    var armed = false;
    var opened = false;
    var busy = false;
    var signedUp = false;
    var barShown = false;
    var barRetries = 0;
    var placeTimer = null;
    var settleTimer = null;
    var retryTimer = null;
    var suggestTimer = null;
    var downOutside = false;

    function on(target, type, handler, options) {
      if (!target) return;
      target.addEventListener(type, handler, options);
      cleanups.push(function () {
        target.removeEventListener(type, handler, options);
      });
    }

    function later(fn, ms) {
      var id = window.setTimeout(fn, ms);
      cleanups.push(function () {
        window.clearTimeout(id);
      });
      return id;
    }

    cleanups.push(function () {
      window.clearTimeout(placeTimer);
      window.clearTimeout(settleTimer);
      window.clearTimeout(retryTimer);
      window.clearTimeout(suggestTimer);
    });

    // Re-read before every automatic open: another tab may have shown the popup or signed up.
    function eligible() {
      var state = readState();
      if (state.d || /(?:^|;\s*)poptin_conver/.test(document.cookie)) return false;
      return !(state.s && nowSec() - state.s < opts.frequency);
    }

    /* Steps, opening and closing */

    function setStep(name) {
      for (var i = 0; i < steps.length; i++) {
        steps[i].hidden = steps[i].getAttribute('data-sfp-step') !== name;
      }
      dialog.setAttribute('aria-labelledby', name === 'done' ? 'sfp-title-done' : 'sfp-title');
    }

    function whenStyled(fn) {
      if (!css || css.media === 'all') return fn();
      if (css.sheet) {
        css.media = 'all';
        return fn();
      }
      var done = false;
      function go() {
        if (done) return;
        done = true;
        css.media = 'all';
        fn();
      }
      on(css, 'load', go);
      later(go, 2500);
    }

    function focusInside(step, trigger) {
      var target = null;
      if (step === 'done') target = root.querySelector('#sfp-title-done');
      else if (trigger === 'return') target = emailInput;
      else if (finePointer()) target = nameInput || emailInput;
      target = target || dialog;
      try {
        target.focus({ preventScroll: true });
      } catch (e) {
        target.focus();
      }
    }

    function open(trigger, step) {
      if (dialog.open) return;
      opened = true;
      armed = false;
      whenStyled(function () {
        if (dialog.open) return;
        hideBar();
        var current = step || (signedUp ? 'done' : 'form');
        setStep(current);
        try {
          dialog.showModal();
        } catch (e) {
          return;
        }
        var scrollbar = window.innerWidth - html.clientWidth;
        html.style.setProperty('--sfp-scrollbar', (scrollbar > 0 ? scrollbar : 0) + 'px');
        html.classList.add('sfp-locked');
        if (!opts.design && trigger !== 'return') writeState({ s: nowSec() });
        focusInside(current, trigger);
        if (trigger === 'return' && document.readyState !== 'complete') {
          // The browser's jump to #sfp-form at page load can pull focus out again.
          on(window, 'load', function () {
            window.setTimeout(function () {
              if (dialog.open && !dialog.contains(document.activeElement)) focusInside(current, trigger);
            }, 0);
          });
        }
        if (!opts.design) publish('sf_exit_popup_shown', { trigger: trigger });
      });
    }

    function close() {
      if (dialog.open) dialog.close();
    }

    on(dialog, 'close', function () {
      html.classList.remove('sfp-locked');
      if (!opts.design && !signedUp) writeState({ s: nowSec() });
    });

    function outside(event) {
      var rect = dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    }

    // A click on the dimmed backdrop closes the popup; a drag that starts inside does not.
    on(dialog, 'pointerdown', function (event) {
      downOutside = event.target === dialog && outside(event);
    });

    on(dialog, 'click', function (event) {
      if (downOutside && event.target === dialog && outside(event)) close();
      downOutside = false;
    });

    var closers = root.querySelectorAll('[data-sfp-close]');
    for (var c = 0; c < closers.length; c++) on(closers[c], 'click', close);

    /* Form */

    function showError(message) {
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.hidden = false;
      if (emailInput) emailInput.setAttribute('aria-invalid', 'true');
    }

    function clearError() {
      if (!errorBox) return;
      errorBox.textContent = '';
      errorBox.hidden = true;
      if (emailInput) emailInput.removeAttribute('aria-invalid');
    }

    function fillHidden() {
      if (nameInput && firstInput && lastInput) {
        var full = nameInput.value.replace(/\s+/g, ' ').trim();
        var cut = full.indexOf(' ');
        firstInput.value = cut < 0 ? full : full.slice(0, cut);
        lastInput.value = cut < 0 ? '' : full.slice(cut + 1);
        firstInput.disabled = !firstInput.value;
        lastInput.disabled = !lastInput.value;
      }
      if (noteInput) {
        noteInput.value = opts.saveSource ? sourceNote() : '';
        noteInput.disabled = !noteInput.value;
      }
    }

    function setBusy(state) {
      busy = state;
      if (!submitBtn) return;
      if (state) {
        submitBtn.setAttribute('data-label', submitBtn.textContent);
        submitBtn.setAttribute('aria-busy', 'true');
        submitBtn.textContent = 'Signing you up…';
      } else {
        submitBtn.removeAttribute('aria-busy');
        if (submitBtn.hasAttribute('data-label')) submitBtn.textContent = submitBtn.getAttribute('data-label');
      }
    }

    on(form, 'submit', function (event) {
      if (!emailInput) return;
      if (busy) {
        event.preventDefault();
        return;
      }
      var email = emailInput.value.trim();
      emailInput.value = email;
      if (!EMAIL_RE.test(email)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        showError(email ? 'Enter a valid email address, like name@example.com.' : 'Enter your email address.');
        emailInput.focus();
        return;
      }
      clearError();
      fillHidden();
      setBusy(true);
      // Remember the attempt: Shopify's spam check can drop #sfp-form from the address it
      // returns to, and this lets the thank-you step open anyway.
      if (!opts.design) writeState({ p: nowSec() });
      // Nothing else to do: the browser posts the form to Shopify, which redirects back here.
    });

    // The Back button can restore this page from the browser's cache, still busy, and still on
    // the form after a signup that succeeded.
    on(window, 'pageshow', function (event) {
      if (!event.persisted) return;
      setBusy(false);
      if (opts.design || !readState().d) return;
      signedUp = true;
      hideBar();
      if (dialog.open) setStep('done');
    });

    if (emailInput && suggestBox && suggestBtn) {
      on(emailInput, 'input', function () {
        if (emailInput.getAttribute('aria-invalid') === 'true') clearError();
        // Hide the old hint at once, so a click on it can't overwrite newer typing.
        suggestBox.hidden = true;
        window.clearTimeout(suggestTimer);
        suggestTimer = window.setTimeout(function () {
          var hint = suggestEmail(emailInput.value.trim());
          suggestBtn.textContent = hint;
          suggestBox.hidden = !hint;
        }, 700);
      });
      on(suggestBtn, 'click', function () {
        emailInput.value = suggestBtn.textContent;
        suggestBox.hidden = true;
        emailInput.focus();
      });
    }

    if (copyBtn && codeEl) {
      var copyLabel = copyBtn.textContent;
      on(copyBtn, 'click', function () {
        var code = codeEl.textContent.trim();
        function copied() {
          copyBtn.textContent = 'Copied';
          later(function () {
            copyBtn.textContent = copyLabel;
          }, 2000);
        }
        function selectCode() {
          var range = document.createRange();
          range.selectNodeContents(codeEl);
          var selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
          try {
            if (document.execCommand('copy')) copied();
          } catch (e) {
            /* the code stays selected for a manual copy */
          }
        }
        if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(copied, selectCode);
        else selectCode();
      });
    }

    /* Desktop: exit intent and the optional timer */

    function armDesktop() {
      later(function () {
        armed = true;
        var img = root.querySelector('.sfp-media__img');
        if (img) img.loading = 'eager'; // fetch the photo now so it is ready when the popup opens
      }, opts.armDelay);
      on(document, 'mouseout', function (event) {
        if (!armed || event.relatedTarget || event.clientY > 12) return;
        if (eligible()) open('exit');
        else armed = false;
      });
      if (opts.timer > 0) {
        var fire = function () {
          if (opened) return;
          if (document.hidden) {
            // Not in a background tab: wait until the visitor is looking at this one.
            var onVisible = function () {
              if (document.hidden) return;
              document.removeEventListener('visibilitychange', onVisible);
              fire();
            };
            on(document, 'visibilitychange', onVisible);
            return;
          }
          if (eligible()) open('timer');
        };
        later(fire, opts.timer);
      }
    }

    /* Phones and tablets: the offer bar */

    function topHit(x, y) {
      var stack = document.elementsFromPoint ? document.elementsFromPoint(x, y) : [document.elementFromPoint(x, y)];
      for (var i = 0; i < stack.length; i++) {
        var el = stack[i];
        if (!el || root.contains(el)) continue;
        // Widgets drawn inside a shadow root (the chat widget is) report only their host: look inside.
        for (var depth = 0; depth < 5 && el.shadowRoot && el.shadowRoot.elementFromPoint; depth++) {
          var inner = el.shadowRoot.elementFromPoint(x, y);
          if (!inner || inner === el) break;
          el = inner;
        }
        return el;
      }
      return null;
    }

    // Height of whatever is pinned to the bottom of the screen on the left (a cookie banner,
    // a sticky add-to-cart bar, the theme preview bar) so the bar can sit above it.
    // Returns -1 when something taller than 30% of the screen is there.
    function bottomInset() {
      var height = window.innerHeight;
      var limit = height * 0.7;
      var top = height;
      for (var y = height - 4; y > limit; y -= 8) {
        var hit = topHit(16, y);
        if (!hit || !pinnedBox(hit)) break;
        top = y - 4;
      }
      return top <= limit + 8 ? -1 : height - top;
    }

    // Checks the spot where the bar would sit. Small pinned things floating there (a chat
    // greeting, a badge) push the bar up above them. A menu, drawer or other overlay taller than
    // 30% of the screen returns -1: the bar then hides, so it never catches the overlay's taps.
    function clearOf(inset) {
      var height = window.innerHeight;
      var barHeight = bar.offsetHeight || 44;
      var width = bar.offsetWidth || 240;
      var xs = [24, 12 + width / 2, 4 + width];
      for (var round = 0; round < 4; round++) {
        var bottom = height - 12 - inset;
        var ys = [bottom - barHeight + 4, bottom - 4];
        var highest = null;
        for (var a = 0; a < ys.length; a++) {
          for (var b = 0; b < xs.length; b++) {
            var box = pinnedBox(topHit(Math.min(xs[b], window.innerWidth - 4), ys[a]));
            if (!box) continue;
            var rect = box.getBoundingClientRect();
            if (rect.height > height * 0.3) return -1;
            highest = highest === null ? rect.top : Math.min(highest, rect.top);
          }
        }
        if (highest === null) return inset;
        inset = Math.ceil(height - highest - 4); // bar's bottom edge 8px above it
        if (inset > height * 0.4) return -1;
      }
      return -1; // still crowded after three moves
    }

    // Returns -1 when the bar can't be shown right now.
    function placeBar() {
      var inset = bottomInset();
      if (inset >= 0) inset = clearOf(inset);
      if (inset >= 0) bar.style.setProperty('--sfp-lift', inset + 'px');
      if (barShown) bar.style.visibility = inset < 0 ? 'hidden' : '';
      return inset;
    }

    function queuePlace(delay) {
      if (placeTimer) return;
      placeTimer = window.setTimeout(function () {
        placeTimer = null;
        placeBar();
      }, delay);
    }

    function hideBar() {
      if (!bar) return;
      bar.classList.remove('is-visible');
      bar.hidden = true;
      bar.style.visibility = '';
    }

    function showBar(force) {
      if (!bar || barShown || opened || dialog.open) return;
      if (!force && !eligible()) return;
      if (placeBar() < 0) {
        // Something covers the bottom of the screen (a large cookie banner, an open menu).
        if (!retryTimer && barRetries < 20) {
          barRetries += 1;
          retryTimer = window.setTimeout(function () {
            retryTimer = null;
            showBar(force);
          }, 3000);
        }
        return;
      }
      barShown = true;
      bar.style.visibility = '';
      bar.hidden = false;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          bar.classList.add('is-visible');
        });
      });
      if (!opts.design) writeState({ b: nowSec() });
      on(window, 'scroll', function () {
        queuePlace(300);
      }, { passive: true });
      on(window, 'resize', function () {
        queuePlace(200);
      });
      // A tap can open or close a menu, drawer or banner: look again once it has moved.
      on(document, 'click', function () {
        queuePlace(350);
        window.clearTimeout(settleTimer);
        settleTimer = window.setTimeout(placeBar, 1000);
      }, true);
      on(document, 'visibilitychange', function () {
        // Signed up in another tab meanwhile.
        if (!document.hidden && readState().d) hideBar();
      });
      if (!opts.design) publish('sf_exit_popup_bar_shown', {});
    }

    function armBar(state) {
      if (!bar) return;
      if (state.b && nowSec() - state.b < BAR_FOLLOW_SECONDS) {
        later(showBar, 1500); // already seen this visit: follow the visitor to the next page
        return;
      }
      var started = Date.now();
      var deepest = 0;
      var lastCheck = 0;
      var trailing = null;
      cleanups.push(function () {
        window.clearTimeout(trailing);
      });
      // Runs at most every 400 ms: placing the bar measures the page, too costly for every scroll event.
      function check() {
        if (barShown) return;
        var wait = 400 - (Date.now() - lastCheck);
        if (wait > 0) {
          if (!trailing) {
            trailing = window.setTimeout(function () {
              trailing = null;
              check();
            }, wait);
          }
          return;
        }
        lastCheck = Date.now();
        var room = Math.max(document.documentElement.scrollHeight - window.innerHeight, 0);
        var needed = Math.min(window.innerHeight * 0.5, room * 0.5);
        if (Date.now() - started >= opts.mobileDelay && deepest >= needed) showBar();
      }
      on(window, 'scroll', function () {
        deepest = Math.max(deepest, window.pageYOffset || document.documentElement.scrollTop || 0);
        check();
      }, { passive: true });
      later(check, opts.mobileDelay + 100);
    }

    if (bar) {
      on(bar.querySelector('[data-sfp-open]'), 'click', function () {
        if (opts.design) return open('bar', opts.editorStep);
        if (readState().d) return hideBar(); // signed up in another tab meanwhile
        open('bar');
      });
      on(bar.querySelector('[data-sfp-bar-close]'), 'click', function () {
        hideBar();
        if (!opts.design) writeState({ s: nowSec() });
      });
    }

    /* Theme editor preview */

    function preview(active) {
      if (!active) {
        close();
        hideBar();
        return;
      }
      if (bar && window.innerWidth < 750 && !dialog.open) {
        bar.style.setProperty('--sfp-lift', '0px');
        bar.style.visibility = '';
        bar.hidden = false;
        bar.classList.add('is-visible');
        return;
      }
      if (dialog.open) setStep(opts.editorStep);
      else open('editor', opts.editorStep);
    }

    /* Start */

    rememberLanding();

    var params = null;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      params = null;
    }
    var qa = params ? params.get('sf_popup') : null;
    var posted = !!(params && params.get('customer_posted') === 'true');
    var state = readState();
    // Coming back from our own post: the address ends in #sfp-form, or this browser sent the
    // popup's form in the last 30 minutes (Shopify's spam check can drop the #sfp-form part).
    var ours = window.location.hash === '#sfp-form' || !!(state.p && nowSec() - state.p < 1800);
    var serverError = !!(errorBox && !errorBox.hidden && errorBox.textContent.trim());

    // Shopify renders a newsletter error into every customer form on the page; keep only ours.
    if (serverError && !ours) {
      clearError();
      serverError = false;
    }

    if (!opts.design) {
      if (qa === 'reset') {
        clearState();
        state = {};
      } else if (Object.keys(state).length) {
        writeState({}); // Safari keeps script-set cookies 7 days from the last write: renew it
      }

      if (posted) {
        // Someone just subscribed through a newsletter form (this one or the footer's).
        signedUp = true;
        writeState({ d: 1, p: 0 });
        if (ours) {
          open('return', 'done');
          cleanUrl();
          publish('sf_exit_popup_signup', {});
          try {
            document.dispatchEvent(new CustomEvent('sf:exit-popup:signup'));
          } catch (e) {
            /* very old browsers */
          }
        }
      } else if (ours && serverError) {
        writeState({ p: 0 });
        if (emailInput) emailInput.setAttribute('aria-invalid', 'true');
        open('return', 'form');
        cleanUrl();
      } else if (qa === 'open') {
        open('qa');
      } else if (qa === 'bar') {
        showBar(true);
      } else if (!opts.subscribed && eligible()) {
        if (finePointer()) armDesktop();
        else if (opts.mobile) armBar(state);
      }
    }

    return {
      root: root,
      preview: preview,
      destroy: function () {
        cleanups.forEach(function (fn) {
          fn();
        });
        cleanups = [];
        close();
        hideBar();
        html.classList.remove('sfp-locked');
      }
    };
  }

  function boot() {
    var root = document.getElementById('sf-exit-popup');
    if (!root || root.hasAttribute('data-sfp-ready')) return;
    root.setAttribute('data-sfp-ready', '');
    if (instance) instance.destroy();
    instance = create(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector || !event.target.querySelector('#sf-exit-popup')) return;
    boot();
    if (instance) instance.preview(true);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (instance && event.target && event.target.contains && event.target.contains(instance.root)) {
      instance.destroy();
      instance = null;
    }
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (instance && event.target && event.target.contains && event.target.contains(instance.root)) instance.preview(true);
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    if (instance && event.target && event.target.contains && event.target.contains(instance.root)) instance.preview(false);
  });
})();
